<template>
    <CascadingScalePerformanceValuesInput
      v-if="scope.row.isFieldViewable(performanceValueName)"
      v-model="scope.row.model"
      :disabled="!scope.row.isFieldEditable(performanceValueName)"
      :performance-value-name="performanceValueName"
      style="width: 100%"
      @change="scope.row.save()"
    ></CascadingScalePerformanceValuesInput>
  <CascadingElementHiddenProp v-else>{{scope.row.getHiddenPlaceholder(performanceValueName)}}</CascadingElementHiddenProp>
</template>

<script>

import CascadingScalePerformanceValuesInput from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingElementHiddenProp from "@/modules/cascading/components/CascadingElementHiddenProp.vue";

export default {
  name: 'cascading-scale-performance-values-input-table-column',
  components: { CascadingElementHiddenProp, ClickToEdit, CascadingScalePerformanceValuesInput},
  mixins: [],

  props: {
    scope: {type: Object, required: false},
    performanceValueName: {type: String, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
